import React from 'react'

import {FeaturePanel} from '@/components/feature-panel'
import PrismicLink from '@/components/prismic-link'
import type {FeaturePanelFragment, FeaturePanelSecondaryFragment} from '@/graphql-types'
import {getVideoSources} from '@/utils/get-video-sources'
import type {BackgroundColor} from '@/utils/is-valid-background-color'
import type {FontColor} from '@/utils/is-valid-font-color'

export interface Props {
    slice: FeaturePanelFragment | FeaturePanelSecondaryFragment
}

export const FeaturePanelSlice = React.forwardRef<HTMLDivElement, Props>(
    ({slice: {primary: data}}, ref) => {
        const video = getVideoSources({
            webm: data.video_webm,
            mp4: data.video_mp4,
        })

        return (
            <FeaturePanel
                image={data.image}
                video={video}
                backgroundColor={data.background_color as BackgroundColor}
                isMediaOnTheRight={data.is_media_on_the_right}
                subtitle={data.subtitle}
                subtitleColor={data.subtitle_color as FontColor}
                title={data.title}
                content={data.content.richText}
                ref={ref}
                CTA={(props) => (
                    <PrismicLink {...props} {...data.cta_link}>
                        {data.cta_label}
                    </PrismicLink>
                )}
            />
        )
    },
)
